var exports = {
  "p$": "DMChannelView.module__emptyState___Y08wYm",
  "AI": "DMChannelView.module__emptyStateIcon___Y08wYm",
  "vo": "DMChannelView.module__emptyStateTitle___Y08wYm",
  "Li": "DMChannelView.module__emptyStateDescription___Y08wYm",
  "fX": "DMChannelView.module__callParticipantsRow___Y08wYm",
  "gN": "DMChannelView.module__compactCallParticipantsRow___Y08wYm",
  "Gr": "DMChannelView.module__callParticipant___Y08wYm",
  "Gj": "DMChannelView.module__callParticipantAvatar___Y08wYm",
  "I9": "DMChannelView.module__callParticipantRinging___Y08wYm",
  "Jn": "DMChannelView.module__callBanner___Y08wYm",
  "nY": "DMChannelView.module__callBannerBody___Y08wYm",
  "c7": "DMChannelView.module__callBannerResizable___Y08wYm",
  "oo": "DMChannelView.module__callControlBarSection___Y08wYm",
  "Pf": "DMChannelView.module__callControlBarInner___Y08wYm",
  "tX": "DMChannelView.module__callControls___Y08wYm",
  "pm": "DMChannelView.module__callBannerMobile___Y08wYm",
  "h8": "DMChannelView.module__callBannerMobileLabel___Y08wYm",
  "ZI": "DMChannelView.module__callControlsMobile___Y08wYm",
  "IX": "DMChannelView.module__compactCallResizeHandle___Y08wYm",
  "rF": "DMChannelView.module__compactCallResizePill___Y08wYm",
};

module.exports = exports;
